// extracted by mini-css-extract-plugin
export default {"centerScreenNotification":"ckL8ufkxQ9CwRiufSV0w"};